<template>
  <section>
    <EditDialog ref="editDialog" @sub="handleEditSub" />
    <ChooseShroud
      :otherSearchData="{
        isVehicleFee: true,
        standingBookType: 2,
      }"
      ref="chooseShroud"
      :customShow="true"
      @change="handleEditSub" />
    <span class="primary cur addBtn" @click="showEdit()">添加</span>
    <span class="primary cur" @click="showChoose()">选择</span>
    <!-- 表格 -->
    <section class="tableBox" v-show="resultVal.length !== 0">
      <el-table
        v-loading="tableData.loading"
        ref="multipleTable"
        :data="resultVal"
        tooltip-effect="dark"
      >
        <!-- 常规列表项 -->
        <el-table-column
          v-for="(item, index, key) in tableData.title"
          :key="key"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minW"
          :width="item.w"
        />
        <!-- 常规列表项 end -->
        <!-- 操作按钮 -->
        <el-table-column prop="control" label="操作" width="160">
          <template slot-scope="scope">
            <section>
              <!-- 操作按钮 -->
              <qx-permpisions permpisions="">
                <span class="primary cur" @click="showEdit(scope.row)">修改</span>
              </qx-permpisions>
              <qx-permpisions permpisions="">
                <span class="primary cur" @click="del(scope.row)">删除</span>
              </qx-permpisions>
              <!-- 操作按钮 end -->
            </section>
          </template>
        </el-table-column>
        <!-- 操按钮 end -->
      </el-table>
    </section>
    <!-- 表格 end -->
  </section>
</template>

<script>
import EditDialog from './editDialog';
import ChooseShroud from 'components/choose/shroud';
export default {
  components: {
    EditDialog,
    ChooseShroud,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'installDate',
            label: '安装时间',
          },
          {
            prop: 'purchaseFee',
            label: '采购原价',
          },
          {
            prop: 'payAmt',
            label: '申请金额（元）',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    showEdit (item) {
      this.$refs.editDialog.show(item);
    },
    showChoose () {
      this.$refs.chooseShroud.show();
    },
    handleEditSub (item) {
      if (!item.form) { // 选择
        const resultValIds = this.resultVal.map((item) => item.id);
        item.forEach((d) => {
          if (resultValIds.indexOf(d.id) === -1) {
            // d.payAmt = d.certificatesInsuranceFee;
            this.resultVal.push(d);
          }
        });
      } else if (item.originData) { // 修改
        const index = this.resultVal.indexOf(item.originData);
        this.resultVal.splice(index, 1, item.form);
      } else { // 新增
        this.resultVal.push(item.form);
      }
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
    del (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('cc', this.resultVal);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style scoped lang="scss">
.addBtn{
  margin-right: 16px;
}
</style>
